import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./MapPrompt.css";

function MapPrompt({ onClose }) {
  return (
    <div className="quiz-prompt-popup">
      <p>
        Thinking about moving to a new neighborhood? Or interested in the crime
        rate of different suburbs? Come check out our suburb safety map!
      </p>
      <div className="quiz-prompt-buttons">
        <Link to="/map" style={{ textDecoration: "none" }}>
          <button className="btn take-quiz-btn">Let's Go</button>
        </Link>
        <button className="btn no-thanks-btn" onClick={onClose}>
          No Thanks
        </button>
      </div>
    </div>
  );
}

export default MapPrompt;
